"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var react_fast_compare_1 = __importDefault(require("react-fast-compare"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var IndicatorLinks_1 = require("../_IndicatorLinks/IndicatorLinks");

var JumpLink_1 = require("./JumpLink");

var JumpLinks =
/** @class */
function (_super) {
  __extends(JumpLinks, _super);

  function JumpLinks() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      activeId: "",
      clickedId: ""
    };

    _this.handleScroll = function () {
      var stickyElementsHeight = utils_1.WindowEvents.getStickyElementsHeight();

      if (_this.firstElm.getBoundingClientRect().top > stickyElementsHeight) {
        // the container
        _this.containerElm.style.position = "static";
        _this.containerElm.style.width = "auto";
        _this.containerElm.style.left = "auto";

        _this.unregisterResponsiveUpdates();
      } else if (_this.containerElm.offsetHeight < _this.lastElm.getBoundingClientRect().bottom) {
        // else if the container still fits, set Fixed
        _this.registerResponsiveUpdates();

        _this.containerElm.style.position = "fixed";
        _this.containerElm.style.top = stickyElementsHeight + "px";
      } else if (_this.lastElm.getBoundingClientRect().top + _this.lastElm.offsetHeight <= _this.containerElm.offsetHeight) {
        // when the JumpLinks Container's bottom distance gets bigger than the last elements', set the JumpLinks Container to position absolute
        _this.registerResponsiveUpdates();

        _this.containerElm.style.position = "absolute";
        _this.containerElm.style.top = _this.lastElm.offsetTop + _this.lastElm.offsetHeight - _this.containerElm.offsetHeight + "px";

        if (_this.containerElm.getBoundingClientRect().top + _this.containerElm.offsetHeight < 0) {
          _this.unregisterResponsiveUpdates();
        }
      }
    };

    _this.setupListeners = function (removeListeners) {
      if (removeListeners === void 0) {
        removeListeners = false;
      }

      if (removeListeners) {
        utils_1.WindowEvents.removeVisibilityCallback(_this.handleVisibility);
        utils_1.WindowEvents.removeScrollCallback(_this.handleScroll);
      }

      _this.targetIds = React.Children.toArray(_this.props.children).filter(function (child) {
        return typeof child !== "string" && child.type === JumpLink_1.JumpLink;
      }).map(function (child) {
        return child.props.targetId;
      });
      _this.firstElm = _this.targetIds && _this.targetIds.length && document.getElementById(_this.targetIds[0]);
      _this.lastElm = _this.targetIds && _this.targetIds.length && document.getElementById(_this.targetIds[_this.targetIds.length - 1]);
      utils_1.WindowEvents.addVisibilityCallback(_this.handleVisibility, _this.targetIds, utils_1.WindowEvents.Visibility.TOP_CLIPPED);
      if (_this.firstElm && _this.lastElm) utils_1.WindowEvents.addScrollCallback(_this.handleScroll);
    };

    _this.responsiveUpdates = function () {
      _this.containerElm.style.left = _this.containerElm.parentElement.offsetLeft + "px";
      _this.containerElm.style.width = _this.containerElm.parentElement.offsetWidth + "px";
    };

    _this.registerResponsiveUpdates = function () {
      if (!_this.setLeftListenerRegistered) {
        utils_1.WindowEvents.addResizeCallback(_this.responsiveUpdates);
        _this.setLeftListenerRegistered = true;
      }
    };

    _this.unregisterResponsiveUpdates = function () {
      if (_this.setLeftListenerRegistered) {
        utils_1.WindowEvents.removeResizeCallback(_this.responsiveUpdates);
        _this.setLeftListenerRegistered = false;
      }
    };

    _this.handleVisibility = function (activeIds) {
      var activeId = activeIds.length > 0 ? activeIds[0] : _this.targetIds[0];

      if (activeId !== _this.state.activeId) {
        _this.setState(function (prevState) {
          return {
            activeId: activeId,
            clickedId: prevState.clickedId && activeId === prevState.clickedId ? "" : prevState.clickedId
          };
        });
      }
    };

    return _this;
  }

  JumpLinks.prototype.componentDidMount = function () {
    this.setupListeners();
  };

  JumpLinks.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.onChange !== this.props.onChange || !react_fast_compare_1["default"](prevProps.children, this.props.children)) {
      this.setupListeners(true);
    }
  };

  JumpLinks.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeVisibilityCallback(this.handleVisibility);
    utils_1.WindowEvents.removeScrollCallback(this.handleScroll);
    this.unregisterResponsiveUpdates();
  };

  JumpLinks.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        className = _a.className,
        children = _a.children,
        otherProps = __rest(_a, ["id", "className", "children"]);

    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "jumplinks-container",
      ref: function ref(r) {
        return _this.containerElm = r;
      },
      id: id
    }, React.createElement(IndicatorLinks_1.IndicatorLinks, __assign({}, otherProps, {
      activeId: (this.state.clickedId ? this.state.clickedId : this.state.activeId) + "-jumplink",
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "jumplinks", className]),
      indicator: true
    }), React.Children.toArray(children).map(function (child) {
      return child.type === JumpLink_1.JumpLink ? React.cloneElement(child, {
        id: child.props.targetId + "-jumplink",
        key: child.props.targetId + "-jumplink",
        onClick: function onClick(ev) {
          if (window.innerHeight < document.body.offsetHeight - document.getElementById(child.props.targetId).offsetTop) {
            _this.setState({
              clickedId: child.props.targetId
            });
          }

          return child.props.onClick && child.props.onClick(ev);
        }
      }) : React.cloneElement(child, {
        key: uniqid_1["default"]("jumplinks-child")
      });
    })));
  };

  JumpLinks.Link = JumpLink_1.JumpLink;
  return JumpLinks;
}(React.Component);

exports.JumpLinks = JumpLinks;